import React from 'react';
import { ChatBubbleLeftRightIcon, SparklesIcon } from '@heroicons/react/24/outline';
import { useChat } from '../contexts/ChatContext';

interface AIChatButtonProps {
  className?: string;
}

const AIChatButton: React.FC<AIChatButtonProps> = ({
  className = ''
}) => {
  const { openChat, isOpen } = useChat();

  return (
    <>
      {/* AI Chat Floating Action Button - Desktop Only */}
      {!isOpen && (
        <button
          onClick={() => openChat({ fullScreen: true })}
          className={`fixed bottom-8 right-8 w-16 h-16 bg-gradient-to-br from-indigo-600 to-violet-700 text-white rounded-full shadow-2xl hover:shadow-indigo-200/50 hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center z-[60] border-2 border-white/20 backdrop-blur-sm ${className} group`}
          aria-label="Open AI Chat"
          title="Profstudymate"
        >
          <div className="relative">
            <ChatBubbleLeftRightIcon className="h-8 w-8 text-white" />
            <div className="absolute -top-1 -right-1">
              <SparklesIcon className="h-4 w-4 text-yellow-300 animate-pulse" />
            </div>
          </div>
        </button>
      )}
    </>
  );
};

export default AIChatButton;
